import PropTypes from 'prop-types'
import classNames from 'classnames'
import Button from '../button'

import Typography from '../typography'
import styles from '../../../styles/bantrab/components/card.module.scss'

const Blog = ({ title, textContent, date, sales, read, ...attrs }) => {
  const { className } = attrs
  attrs.className = classNames(className, {
    [styles.blog]: true
  })

  return (
    <div {...attrs}>
      <figure>
      </figure>
      <div className='flex flex-row justify-between items-center mt-4 mb-4'>
        <Typography tag={'span'} size='three' weight='medium' className='text-green-500'>
          {sales}
        </Typography>
        <Typography tag={'span'} size='two' weight='regular' className='text-gray-400  '>
          {date}
        </Typography>
      </div>
      <Typography tag={'h3'} size="four" weight="bold" className='mb-2'>
        {title}
      </Typography>
      <Typography tag={'p'} size="two" weight="regular" className='text-gray-400 mb-6'>
        {read}
      </Typography>
      <Typography className="text-gray-400 mb-4">
        {textContent}
      </Typography>

      <Button
        arrow
        href="https://www.google.com"
        iconRight
        large
        target="_blank"
      >
        Leer mas
      </Button>
    </div>
  )
}

Blog.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  date: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  sales: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  read: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  textContent: PropTypes.oneOfType([PropTypes.string, PropTypes.node])

}

export default Blog
